import { parseJson } from './safeJson'

function resolveErrorPayload(error) {
  if (!error) return null

  if (error.response && Object.prototype.hasOwnProperty.call(error.response, 'data')) {
    return parseJson(error.response.data, error.response.data)
  }

  if (Object.prototype.hasOwnProperty.call(error, 'data')) {
    return parseJson(error.data, error.data)
  }

  return error
}

export function parseApiError(error, fallbackMessage = 'Unexpected error') {
  const payload = resolveErrorPayload(error)
  const status = error?.response?.status ?? error?.status ?? null
  let reason = fallbackMessage

  if (payload && typeof payload === 'object') {
    reason = payload.reason || payload.message || payload.error || fallbackMessage
  } else if (typeof payload === 'string' && payload.length) {
    reason = payload
  } else if (error?.message) {
    reason = error.message
  }

  return {
    status,
    reason,
    payload,
    message: reason,
  }
}

export function formatApiError(error, fallbackMessage = 'Unexpected error', prefix = '') {
  const parsed = parseApiError(error, fallbackMessage)
  const reason = parsed.reason || fallbackMessage

  return `${reason === fallbackMessage ? '' : prefix}${reason}`
}
